import { render, staticRenderFns } from "./InternalThresholds.vue?vue&type=template&id=69d5842a&scoped=true"
import script from "./InternalThresholds.vue?vue&type=script&lang=js"
export * from "./InternalThresholds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d5842a",
  null
  
)

export default component.exports